export default __webpack_public_path__ + "static/media/Best Pizza.f5492127.png";